import { CheckboxState } from '@components/checkbox';

// Select all applies to the values it is given and only those, so a selection
// it wasn't offered survives either direction.
export const applySelectAll = ({
  selected,
  values,
  isSelected,
}: {
  selected: Array<string>;
  values: Array<string>;
  isSelected: boolean;
}): Array<string> => {
  if (isSelected) {
    return selected.concat(values.filter((value) => !selected.includes(value)));
  }

  return selected.filter((value) => !values.includes(value));
};

// Save is only live once the draft differs from what the cell holds, and for a
// list of options that means the same set - the draft is built in list order,
// the value in whatever order the API returned.
export const isSameSelection = (selected: Array<string>, current: Array<string>): boolean =>
  selected.length === current.length && selected.every((value) => current.includes(value));

// The designs draw Select all as a dash, not a tick, once part of the list is
// on - so it reads as "some of these" rather than claiming everything.
export const getSelectAllState = ({
  selected,
  values,
}: {
  selected: Array<string>;
  values: Array<string>;
}): CheckboxState => {
  const selectedCount = values.filter((value) => selected.includes(value)).length;

  if (selectedCount === 0) {
    return false;
  }

  return selectedCount === values.length ? true : 'mixed';
};
